/**
 * 위험도 등급 그룹(상/중/하) 유틸
 *  - 1~3 (매우낮음), 4~6 (낮음)      => 하
 *  - 8 (보통), 9~12 (약간높음)       => 중
 *  - 15 (높음), 16~20 (매우높음)     => 상
 */

// 위험도 점수(가능성 × 중대성) 기준
export function getRiskGroupByScore(score) {
  const n = Number(score);
  if (!n || isNaN(n)) return "";
  if (n <= 6) return "하";
  if (n <= 12) return "중";
  return "상";
}

// 위험도 등급 코드(A~F) 기준
export function getRiskGroupByGrade(grade) {
  switch (grade) {
  case "A":
  case "B":
    return "상";
  case "C":
  case "D":
    return "중";
  case "E":
  case "F":
    return "하";
  default:
    return "";
  }
}

// 위험도 한글 등급명 기준
export function getRiskGroupByLabel(label) {
  switch (label) {
  case "매우높음":
  case "높음":
    return "상";
  case "약간높음":
  case "보통":
    return "중";
  case "낮음":
  case "매우낮음":
    return "하";
  default:
    return "";
  }
}
